import axios, { AxiosResponse } from 'axios';
import {
  PurchaseResetCheckoutPayload,
  PurchaseResetPackage,
} from '@src/types/purchaseReset';

export const fetchPurchaseResetPackage = (): Promise<
  AxiosResponse<PurchaseResetPackage>
> => {
  return axios.get('/account-reset/package');
};

export const submitPurchaseResetCheckout = (
  payload: PurchaseResetCheckoutPayload
): Promise<AxiosResponse<{ id?: string; url?: string }>> => {
  return axios.post('/account-reset/', payload);
};
